import MDBox from "components/MDBox";
import WYSIWYG from "components/WYSIWYG/WYSIWYG";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import { Controller, useFormContext } from "react-hook-form";
import { WorksheetItemInput } from "DDD/action-objects/WorksheetItemUpdate";
import { worksheetOnlyDeadPlaceholders } from "constants/PlaceholderTypes";

type WorksheetSowFieldProps = {
  isReadOnly?: boolean;
};

export default function WorksheetSowField({ isReadOnly }: WorksheetSowFieldProps) {
  const { control } = useFormContext<WorksheetItemInput>();

  return (
    <MDBox
      sx={{
        border: `1px solid ${draftColors.border}`,
        borderRadius: "8px",
        p: "6px",
        "& .ck-editor__top": { fontSize: "11px" },
        "& .ck-editor__main": { minHeight: "60px", maxHeight: "140px", overflow: "auto" },
        "& .ck-content": { fontSize: "12px", minHeight: "60px", padding: "4px 8px" },
      }}
    >
      <Controller
        control={control}
        name="statementOfWork"
        render={({ field }) => (
          <WYSIWYG
            type="proposalProduct"
            hidePlaceholders={worksheetOnlyDeadPlaceholders}
            content={field.value}
            onChange={(content) => field.onChange(content ?? "")}
            title="Statement of Work"
            disabled={isReadOnly}
          />
        )}
      />
    </MDBox>
  );
}
